module.exports = __webpack_public_path__ + "media/images/sales/smakon/mv-8ce33e9839e2f5888e064c92e22c21f0.svg";